import React from 'react';
import { Row, Col } from 'react-bootstrap';
import { Link, NavLink } from 'react-router-dom';
import { Images } from "../components";

class NavigationBar extends React.Component {
    constructor(props) {
        super(props);
        this.state = {

        }
    }


    componentDidMount() {

    }

    getRefLeagueActive = () => {

        let refLeagueUrls = ["/dashboard/:tab_id", "/profile", "/leaderboard", '/create-contest', "/my-contest", "/private-contest"];
        let refPAyUrls = ["/refpay", "/add-funds", "/withdraw"];
        let refLiveUrls = ["/my-games/:tab_id"];

        let param = this.props.match.path;
        if (param && !refPAyUrls.includes(param) && !refLiveUrls.includes(param)) {
            return true;
        }
        return false;
    }

    render() {
        return (
            <React.Fragment>

                <div className={'navigation-bar'}>
                    <Row className={'men-lnk-wrp'}>
                        {/* <Col xs={3}>
                            <Link className={this.getRefLeagueActive() ? 'active' : ''} to={'/dashboard/0'}>
                                <div className={'men-lnk'} >
                                    <img src={Images.REFPREDICTOR} />
                                    <span>ReFLeague</span>
                                </div>
                            </Link>

                        </Col>
                        <Col xs={3}>
                            <NavLink to={'/refSocial'}>
                                <div className={'men-lnk'} >
                                    <img src={Images.REFSOCIAL} />
                                    <span>ReFSocial</span>
                                </div>
                            </NavLink>
                        </Col>
                        <Col xs={3}>
                            <NavLink to={'/refpay'}>
                                <div className={'men-lnk'} >
                                    <img src={Images.REFPAY} />
                                    <span>ReFPay</span>
                                </div>
                            </NavLink>
                        </Col>
                        <Col xs={3}>
                            <NavLink to={'/my-games/0'}>
                                <div className={'men-lnk'} >
                                    <img src={Images.REFLIVE} />
                                    <span>ReFLive</span>
                                </div>
                            </NavLink>
                        </Col> */}
                         <Col xs={2}>
                            <NavLink to={'/dashboard/0'}>
                                <div className={'men-lnk'} >
                                    <div className={'ic-wrap'}>
                                        <i className="ic icon-lobby"></i>
                                    </div>
                                    <span>Lobby</span>
                                </div>
                            </NavLink>
                        </Col>

                        <Col xs={2}>
                            <NavLink to={'/my-games/0'}>
                                <div className={'men-lnk'} >
                                    <div className={'ic-wrap'}>
                                        <i className="ic icon-football"></i>
                                    </div>
                                    <span>My Games</span>
                                </div>
                            </NavLink>
                        </Col>

                        <Col xs={2}>
                            <NavLink to={'/leaderboard'}>
                                <div className={'men-lnk'} >
                                    <div className={'ic-wrap'}>
                                        <i className="ic icon-trophy-ic"></i>
                                    </div>
                                    <span>Leaderboard</span>
                                </div>
                            </NavLink>
                        </Col>

                        <Col xs={2}>
                            <NavLink to={'/result'}>
                                <div className={'men-lnk'} >
                                    <div className={'ic-wrap'}>
                                        <i className="ic icon-result"></i>
                                    </div>
                                    <span>My Results</span>
                                </div>
                            </NavLink>
                        </Col>
                         <Col xs={2}>
                            <NavLink to={'/stats-awards'}>
                                <div className={'men-lnk'} >
                                    <div className={'ic-wrap'}>
                                        <i className="ic icon-stats"></i>
                                    </div>
                                    <span>Stats</span>
                                </div>
                            </NavLink>
                        </Col>
                    </Row>
                </div>

            </React.Fragment >
        )
    }
}

export default NavigationBar;